/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React from 'react';

import { MDBBtn } from 'mdb-react-ui-kit';

import "../style/css/button.css"

interface ButtonProps {
    btnName: string;
    onClick: () => void; 
    disable: boolean;
  }

const Button: React.FC<ButtonProps> = ({ btnName, onClick, disable }) =>{

  return (

     <div className='btn' id='btnbox'>
      
      <MDBBtn size='lg' id="button" onClick={onClick} disabled={disable}> {btnName} </MDBBtn>

    </div>

  );
}

export default Button